import {Component, Input, ViewChild} from '@angular/core';
import {MessageService} from "primeng/api";
import {SeverityEnum, ToastMsg} from "../../../model/page";
import {TongueCameraComponent} from "../tongue-camera/tongue-camera.component";

@Component({
  selector: 'tudi-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent {
  @ViewChild(TongueCameraComponent) tongueCamera: TongueCameraComponent;
  @Input() segmentApiSource = 1; // 1 = general, 2 = usana

  constructor(
    private msgService: MessageService
  ) {
  }

  status = 0; // 0 = 尚未選擇圖片或照相, 1 = 正在 segment, 2 = 完成

  showCamera(): void {
    this.tongueCamera.showPhotoCapture();
  }

  showFileUploader(): void {
    this.tongueCamera.show();
  }

  async uploadPhoto(file): Promise<void> {
    this.status = 1;
    const segmentStatus = await this.tongueCamera.segment(this.segmentApiSource);
    if (segmentStatus === 1) {
      this.status = 2;
    } else {
      if (segmentStatus === 2) {
        this.msgService.add(new ToastMsg(SeverityEnum.error, 'Invalid Tongue Image', 'The tongue is too high. Please place it in the center of the photo.'));
      } else if (segmentStatus === 3) {
        this.msgService.add(new ToastMsg(SeverityEnum.error, 'Invalid Tongue Image', 'The tongue is too far to the left. Please place it in the center of the photo.'));
      } else if (segmentStatus === 4) {
        this.msgService.add(new ToastMsg(SeverityEnum.error, 'Invalid Tongue Image', 'The tongue is too far to the right. Please place it in the center of the photo.'));
      } else {
        this.msgService.add(new ToastMsg(SeverityEnum.error, 'Invalid Tongue Image', 'The tongue image could not be recognized.'));
      }
      this.reset();
    }
  }

  reset(): void {
    this.status = 0;
    this.tongueCamera.clear();
  }

  get Image() {
    return this.tongueCamera.croppedImage;
  }

  get DisplayUrl() {
    return this.tongueCamera.croppedDisplayDataUrl;
  }
}
